// extracted by mini-css-extract-plugin
export default {"presetReset":"enterpriseLogo_presetReset__m36kG","xl":"enterpriseLogo_xl__aooai","lg":"enterpriseLogo_lg__t1pLk","md":"enterpriseLogo_md__CEOsA"};